<script>
    export default {
        data() {
            return {
                errorText: '',
            }
        },
        computed: {
            addData() {return this.$store.getters.TAG_DATA_ADD}
        },
        methods: {
            async changeData(event, fieldName, isCheckBox = false) {
                const data = isCheckBox === true ? 
                    event.target.checked :
                    event.target.value;
                this.$store.commit('TAG_DATA_ADD_UPDATE', {
                    fieldName: fieldName, 
                    fieldValue: data,
                });
                this.errorText = await this.$store.dispatch('CHECK_TAG_ADD');
            }
        }
    }
</script>


<template>
    <div class="left_sub_panel_data">
        <label>Name:</label>
        <input
            :value="addData['name']"
            @change="changeData($event, 'name')"
            class="right_input mt_5 mb_10"
            type="text"
        >
        <label>
            <input
                :checked="addData['is_default']"
                @change="changeData($event, 'is_default', true)"
                type="checkbox"
            >
            Default
        </label>
        <label
            v-if="errorText !== ''"
            class="error_text mt_10"
        >{{ errorText }}</label>
    </div>
</template>